import React from 'react'
import PropTypes from 'prop-types'

import styles from './person-form-fields.css'
import SalutationInput from '@/modules/base/components/inputs/salutation-input/salutation-input'
import TextInput from '@/modules/base/components/inputs/text-input/text-input'
import TitleInput from '@/modules/base/components/inputs/title-input/title-input'
import { useFormikContext } from 'formik'

const PersonFormFields = (props) => {
  const { data = {}, errors, onTextInputChange, useFormik = true } = props
  const { salutation, title, firstName, lastName } = data

  const formikContext = useFormikContext()

  const setFormikFieldValue = (name, value) => {
    return formikContext?.setFieldValue(name, value)
  }

  const handleSalutationChange = (option) => {
    const { onSalutationChanged } = props
    onSalutationChanged && onSalutationChanged(option, 'salutation')
    if (useFormik) setFormikFieldValue('salutation', option)
  }

  const handleTitleChange = (option) => {
    const { onTitleChanged } = props
    onTitleChanged && onTitleChanged(option, 'title')
    if (useFormik) setFormikFieldValue('title', option)
  }

  return (
    <div className={styles.container}>
      <div className={styles.row}>
        <div className='col-xs-6'>
          <SalutationInput
            dataQsId='personFormFields-salutation'
            value={salutation}
            onChange={handleSalutationChange}
          />
        </div>
        <div className='col-xs-6'>
          <TitleInput
            dataQsId='personFormFields-title'
            value={title}
            onChange={handleTitleChange}
          />
        </div>
      </div>
      <div className={styles.row}>
        <div className='col-xs-6'>
          <TextInput
            dataQsId='personFormFields-firstName'
            name='firstName'
            label='Vorname'
            value={firstName}
            onChange={onTextInputChange}
          />
        </div>
        <div className='col-xs-6'>
          <TextInput
            required
            dataQsId='personFormFields-lastName'
            name='lastName'
            label='Nachname*'
            value={lastName}
            errorMessage={errors['lastName']}
            onChange={onTextInputChange}
          />
        </div>
      </div>
    </div>
  )
}

PersonFormFields.propTypes = {
  errors: PropTypes.object,
  onSalutationChanged: PropTypes.func,
  onTitleChanged: PropTypes.func,
  onTextInputChange: PropTypes.func,
}

export default PersonFormFields
